import { StrictMode } from "react";
import { createRoot } from "react-dom/client";
import { flushSync } from "react-dom";
import "./styles.css";
import "./site/site.css";
import { App } from "./App.tsx";
import { initErrorReporting } from "./errors.ts";
import { pageMeta, routeFor, type Route } from "./routes.ts";
import { AboutPage, DriverPage, HelpPage, Landing, Legal, NewsPage, RiderPage } from "./site/Site.tsx";
import { PRIVACY, TERMS } from "./site/legal.ts";
import { RegisterPage, UnsubscribePage } from "./site/Register.tsx";

initErrorReporting();

const route = routeFor(window.location.pathname);
const meta = pageMeta[route.page];
document.title = meta.title;
document.body.dataset.page = route.page === "trip" ? "trip" : "site";
if (route.page !== "trip") document.querySelector('meta[name="theme-color"]')?.setAttribute("content", "#FAF8F5");
if (!meta.indexable) {
  const robots = document.createElement("meta");
  robots.name = "robots";
  robots.content = "noindex, nofollow";
  document.head.append(robots);
}

const PAGES: Record<Route["page"], React.ReactNode> = {
  landing: <Landing />,
  driver: <DriverPage />,
  rider: <RiderPage />,
  about: <AboutPage />,
  news: <NewsPage />,
  help: <HelpPage />,
  register: <RegisterPage />,
  unsubscribe: <UnsubscribePage />,
  privacy: <Legal doc={PRIVACY} />,
  terms: <Legal doc={TERMS} />,
  trip: <App />,
};

const root = createRoot(document.getElementById("root")!);
flushSync(() => root.render(<StrictMode>{PAGES[route.page]}</StrictMode>));
// The browser looks for the fragment before the page exists, so /#baixar needs a nudge.
if (window.location.hash) document.getElementById(window.location.hash.slice(1))?.scrollIntoView();
